// How an item's serial and name are shown.
//
// "Concat serial number with Product Name" is a company setting. When it is
// Yes, the company's items must carry a serial, and invoice item dropdowns
// show it in front of the name: "SC1023 - LAPTOP CHARGER". Display only - the
// item's name is never changed, and an item without a serial shows its name
// alone. Mirrored in the mobile app (src/utils/itemDisplay.ts).

/** What the item's `serial` field is called on every screen. */
export const SERIAL_LABEL = "Serial code / Product Code";

export const YES_NO_OPTIONS = ["Yes", "No"];

/**
 * True when the company's setting is Yes. Anything else - No, or a company
 * saved before the setting existed - is No.
 */
export const concatsSerialWithName = (company) =>
  company?.concatSerialWithProductName === "Yes";

/**
 * The item's name, or "SERIAL - NAME" for a company with the setting on.
 * `company` is the invoice's; when it is not known, the item's own company
 * (populated on every item the API returns) answers.
 */
export const itemDisplayName = (item, company) => {
  const name = item?.name ?? "";
  const serial = String(item?.serial ?? "").trim();
  const owner = company ?? item?.companyId;
  return concatsSerialWithName(owner) && serial ? `${serial} - ${name}` : name;
};
